<template>
  <transition name="slide-up">
    <div class="modal-overlay">
      <div class="bottom-modal px-3 pt-1">
        <img
          class="modal-image mt-2 mb-3"
          :src="props.modalHeaderImage"
          alt="shipments_header"
        />
        <p
          class="text-center title-text mb-3"
          v-html="props.modalHeaderTitle"
        ></p>
        <p
          class="text-center subtitle-text mb-5"
          v-html="props.modalHeaderSubtitle"
        ></p>
        <WhatsAppButton class="w-100" @click="modalAction"> </WhatsAppButton>
        <CallCxButton
          v-if="props.showCallCxButton"
          class="w-100 mt-3"
          @click="modalAction2"
        >
        </CallCxButton>
      </div>
    </div>
  </transition>
</template>
<script setup lang="ts">

import WhatsAppButton from "@/apps/credit-line/components/WhatsAppButton.vue";
import CallCxButton from "@/apps/credit-line/components/CallCxButton.vue";

interface Props {
  modalHeaderImage: string;
  modalHeaderTitle: string;
  modalHeaderSubtitle: string;
  showCallCxButton?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modalHeaderImage: "",
  modalHeaderTitle: "",
  modalHeaderSubtitle: "",
  showCallCxButton: false,
});

const emit = defineEmits<{
  (e: "modalAction", value: boolean): void;
  (e: "modalAction2", value?: boolean): void;
}>();

const modalAction = () => {
  emit("modalAction", false);
};

const modalAction2 = () => {
  emit("modalAction2", false);
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 999;
  pointer-events: auto;
}

.bottom-modal {
  background: white;
  width: 100%;
  height: 60%;
  border-radius: 16px 16px 0 0;
  padding: 16px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.modal-image {
  width: 64px;
  height: 64px;
}

.title-text {
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: var(--Typography-Text-1, #111);
  text-align: center;
}

.subtitle-text {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #595a5a;
  text-align: center;
}

.second-button {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #007c3b;
  cursor: pointer;
}
</style>
